<script lang="ts">
    import { derived as sderived, writable } from 'svelte/store'
    import type { Writable } from 'svelte/store'

    import { gettext as _, tgettext } from 'hydria/services/gettext'
    import { simpleFetch } from 'hydria/services/session'
    import { spath } from 'hydria/svelte_helpers'

    import { Breadcrumb } from 'breadcrumb'

    // import InvoiceComment from './InvoiceComment.svelte'
    import PaymentTypes from './PaymentTypes.svelte'
    import TaxExemption from './TaxExemption.svelte'
    import TldYearsAndPrices from './TldYearsAndPrices.svelte'
    import ZonePrice from './ZonePrice.svelte'

    interface Props {
        route: any
    }

    let { route }: Props = $props()

    const _userId: string | undefined = $derived(route.result.path.params?.id)
    // svelte-ignore state_referenced_locally
    const userId: Writable<string | undefined> = writable(_userId)
    const userName: Writable<string | null> = writable(null)

    async function loadUserName(id: string) {
        try {
            const r: any = await simpleFetch('GET', `/json/wdom-user/1/${id}/name`)
            $userName = r.data.name ? r.data.name : r.data.org ? r.data.org : '?'
        } catch {
            $userName = 'inconnu'
        }
    }

    $effect(() => {
        $userId = _userId
        if (_userId) loadUserName(_userId)
    })

    const crumbs = sderived([userId, userName], ([$userId, $userName]) => {
        let o: any

        if ($userId != null) {
            return [
                {
                    txt: $userName ? $userName : '…',
                    url: spath(`/wdom-user/${$userId}`),
                },
                {
                    txt: tgettext('Configuration des TLDs'),
                },
            ]
        } else {
            return [
                {
                    txt: tgettext('Configuration des TLDs'),
                },
            ]
        }
    })
</script>

<Breadcrumb {crumbs} />

<div class="d-grid gap-4">
    {#if $userId}
        <TaxExemption userId={$userId} />

        <!-- <div class="row"> -->
        <!-- <div class="col-sm-6 flex-fill"> -->
        <PaymentTypes userId={$userId} />
        <!-- </div> -->
        <!-- <div class="col-sm-6 flex-fill"> -->
        <!-- <InvoiceComment userId={$userId} /> -->
        <!-- </div> -->
        <!-- </div> -->
    {/if}

    <ZonePrice userId={$userId} />
    <TldYearsAndPrices userId={$userId} />
</div>
